import React, { useEffect, useState, useRef } from "react";
import { Button } from "antd";
import ReactExport from "react-export-excel";
import moment from "moment";
import dateFormat from "dateformat";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;


const Excelldownload = ({ data, data1 }) => {
  console.log("data for excel", data);
  let fileName = "Petty cash Template";
  return (
    <ExcelFile
      element={
        <Button  type="primary">
          Template
        </Button>
      }
      filename={fileName}
    >
      <ExcelSheet data={data.results} name="Attendance Template}">
        <ExcelColumn label="issue_date" value="issue_date" />
        <ExcelColumn label="employee_id" value="employee" />
        <ExcelColumn label="employee_name" value="Employee_name" />
        <ExcelColumn label="amount" value="amount" />
        <ExcelColumn label="location_id" value="location" />
        <ExcelColumn label="location_name" value="Location_name" />
        <ExcelColumn
          label="day_allowance"
          value={(col) => (col.day_allowance ? 1 : null)}
        />
        <ExcelColumn
          label="night_allowance"
          value={(col) => (col.night_allowance ? 1 : null)}
        />
        <ExcelColumn
          label="overtime_allowance"
          value={(col) => (col.overtime_allowance ? 1 : null)}
        />
        <ExcelColumn label="narration" value="narration" />
      </ExcelSheet>
    </ExcelFile>
  );
};

export default Excelldownload;
